var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkMobileIconDis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.904 7.728c0 2.861-2.249 5.181-5.023 5.181-2.774 0-5.023-2.32-5.023-5.181 0-2.862 2.249-5.182 5.023-5.182 2.774 0 5.023 2.32 5.023 5.182zM5.09 19.61c0-2.861 2.25-5.18 5.024-5.18h7.534c2.775 0 5.024 2.319 5.024 5.18 0 2.863-2.25 5.183-5.024 5.183h-7.534c-2.774 0-5.023-2.32-5.023-5.182z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkMobileIconDis);
export default __webpack_public_path__ + "static/media/lkMobileIcon-dis.e01a7b2d5fef12c2b766457caba85581.svg";
export { ForwardRef as ReactComponent };